import React, { FC, useMemo } from 'react';
import Badge from '@atlaskit/badge';
import { OperationDTO } from '@atlassiansox/phobos-client-ts';

import { flexStart, spaceGapCompact, spaceTopCozy, textTransformCapitalize } from '@/styles';
import { KeyValue } from '@/components/primitive';

import { badgeStyles, generalBarStyles } from '../styles';
import { formatCohortName } from '../utils';
import { cohortTitleStyles } from '../slo-panel/styles';

import OperationMembers from './operation-members';

type OperationCohortProps = {
  operations: OperationDTO[];
  cohort: string;
};

const OperationCohort: FC<OperationCohortProps> = ({ operations, cohort }) => {
  const cohortName: string = useMemo(() => formatCohortName(cohort), [cohort]);

  return (
    <div>
      <div css={[flexStart, spaceGapCompact, generalBarStyles, cohortTitleStyles]}>
        <KeyValue noPositionFix title="cohort">
          <Badge>
            <span css={[badgeStyles, textTransformCapitalize]}>{cohortName}</span>
          </Badge>
        </KeyValue>
      </div>
      <div css={spaceTopCozy}>
        <OperationMembers operations={operations} />
      </div>
    </div>
  );
};

export default OperationCohort;
